module.exports = __webpack_public_path__ + "static/media/Q2Mob.60eb7e0a.png";